<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 14:25:11
 * @LastEditTime: 2025-12-25 09:22:11
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-menu_group_item">
    <div class="level_one_wrap" @mousemove="onMousemove">
      <CMenuItem
        :data="data"
        class="cmenu_item_wrap"
        @click.native.stop="$attrs.isFixedMenu ? (isShowChildren = !isShowChildren) : null"
        :isDisabled="true"
        v-bind="$attrs"
        :isUseCustomStr="$attrs.isFixedMenu"
        :customStr="data.meta.title"
        ><div class="icon_wrap">
          <img src="@/components/aiChat/images/svg/historyIcon.svg" class="icon"/>
        </div>
        <template slot="title">
          <Tooltip
            :data="data.meta"
            v-bind="$attrs"
            :disabled="true"
            :keyName="$attrs.isFixedMenu ? 'title' : 'packName'"
            class="label"
          ></Tooltip>
        </template>
        <template slot="num" v-if="data.meta.num !== null">
          <div class="num">{{ data.meta.num }}</div>
        </template>
        <template slot="arrow" v-if="data.children && data.children.length">
          <img src="@/components/aiChat/images/svg/arrowRightIcon.svg" class="icon" :class="['arrow_icon', isShowChildren ? 'is-rotate' : '']"/>
          <!-- <CustomSvgIcon :icon-class="'arrowRightIcon'" :class="['arrow_icon', isShowChildren ? 'is-rotate' : '']" /> -->
        </template>
      </CMenuItem>
    </div>
    <el-collapse-transition v-if="$attrs.isFixedMenu && data.children && data.children.length">
      <el-scrollbar v-show="isShowChildren" class="children_wrap">
        <div
          v-infinite-scroll="
            () => {
              onLoad()
            }
          "
          :infinite-scroll-disabled="isDisabledScrollProp"
          style="padding-right: 16px"
        >
          <div v-for="(e, i) in data.children" :key="i" class="children_wrap__item" v-show="!e.meta.hidden">
            <div :class="['top_wrap', formatTop(e, i).className]" v-if="formatTop(e, i).isShow">
              {{ formatTop(e, i).label }}
            </div>
            <CMenuItem
              :data="e.meta"
              v-bind="$attrs"
              :class="['cmenu_item_wrap', 'children_wrap__item--cmenu', formatActiveRoute(e)]"
              @click.native.stop="onRouter(e)"
            >
              <template slot="title">
                <Tooltip
                  :data="e.meta"
                  v-bind="$attrs"
                  :keyName="'title'"
                  class="label"
                  :scrollHeight="300"
                  :visible-arrow="true"
                  placement="top"
                  :disabled="true"
                  :enterable="false"
                  :popper-class="`custom_tooltip_popper`"
                ></Tooltip>
              </template>

              <template slot="num" v-if="e.meta.num !== null">
                <div class="num">{{ e.meta.num }}</div>
              </template>
              <template slot="operate" v-if="!e.meta.fixed">
                <Dropdown
                  :list="operateList(e).Array"
                  trigger="hover"
                  :placement="'bottom-start'"
                  :className="`menu_dropdown_class`"
                  @on-click="({ item, index }) => onCommand({ ...item }, { params: e, index: i })"
                >
                  <template #default>
                    <img src="@/components/aiChat/images/more.png" class="moreBtn" @click.stop/>
                    <!-- <div class="more" @click.stop><span>·</span><span>·</span><span>·</span></div> -->
                  </template>
                </Dropdown>
              </template>
            </CMenuItem>
          </div>
        </div>
      </el-scrollbar>
    </el-collapse-transition>

    <div v-if="$attrs.isFixedMenu && data.children && data.children.length == 0" class="no_data_wrap">
      <CustomImage
        :url="require('@/components/aiChat/images/noData.png')"
        :isPreview="false"
        :fit="`scale-down`"
        class="icon"
        borderRadius="0"
      ></CustomImage>
      <div class="text">暂无对话</div>
    </div>

    <CDialog
      ref="cDialog"
      :customClass="'c-menu_group-dialog'"
      @on-update-form="
        params => {
          params.operateType == 'RESET_NAME_FORM' ? $emit('on-reset-name', params) : null
        }
      "
    ></CDialog>
  </div>
</template>

<script>
import CMenuItem from './menuItem.vue'
import CDialog from '@/components/aiChat/components/dialog/index.vue'
import CustomImage from '@/components/aiChat/components/customImage/index.vue'
import Dropdown from '@/components/aiChat/components/dropdown/dropdown.vue'
import Tooltip from '@/components/aiChat/components/tooltip/tooltip.vue'
import { changeMappingHandle } from '@/components/aiChat/utils/tbox.js'
import { fetchEventSourceManager } from '@/components/aiChat/utils/fetchEventSourceManager.js'

export default {
  components: {
    CMenuItem,
    CDialog,
    Tooltip,
    CustomImage,
    Dropdown
  },
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {
          children: []
        }
      }
    },
    isDisabledScrollProp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowChildren: true
    }
  },
  computed: {
    formatTop() {
      return function (params, i) {
        let isShow = false,
          label = '',
          className = ''
        let index = -1
        this.data.children.forEach((e, i) => {
          if (e.sort > 0) {
            index = i
          }
        })
        const op = this.data.children.findIndex(e => {
          if (e.sort == 0) {
            return e
          }
        })
        if (index !== -1) {
          if (i == 0) {
            isShow = true
            label = '置顶'
          }
        }
        if (op !== -1) {
          if (i == op) {
            isShow = true
            label = '我的对话'
            className = 'my_dialog'
          }
        }
        return { isShow, label, className }
      }
    },
    operateList() {
      return function (e) {
        const mapping = {
          sticky: {
            id: 0,
            value: e.sort ? '取消置顶' : '置顶',
            code: 'sticky',
            function: ({ params, index }) => {
              if (params.sort) {
                this.$emit('on-un-sticky', { params, index })
                return
              }
              this.$emit('on-sticky', { params, index })
            }
          },
          resetName: {
            id: 1,
            value: '重命名',
            code: 'resetName',
            function: ({ params }) => {
              this.$refs.cDialog.onShow({
                title: '重命名',
                operateType: 'RESET_NAME_FORM',
                size: '375px',
                top: '15vh',
                id: params.meta.id || '',
                showWordLimit:false,
                maxlength:20,
                formModelData: {
                  content: (params.meta.title || '').substring(0, 20),
                  id: params.meta.id || ''
                }
              })
            }
          },
          del: {
            id: 2,
            value: ' 删除',
            code: 'del',
            function: ({ params, index }) => {
              const html = `<div><i class='el-icon-warning'></i>是否删除该条信息？</div>`
              this.$confirm(html, '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                customClass: 'custom_del_message',
                type: 'warning'
              })
                .then(async () => {
                  this.$emit('on-delete', { params, index })
                })
                .catch(E => {
                  console.log(E)
                })
            }
          }
        }
        return changeMappingHandle(mapping)
      }
    },
    formatActiveRoute() {
      return function (params) {
        let str = ''
        if (this.$attrs.activeRouteProp !== null && this.$attrs.activeRouteProp == params.meta.id) {
          str = 'is-active'
        }
        return str
      }
    }
  },
  methods: {
    onLoad() {
      this.$emit('on-load-scroll')
    },
    onCommand(params, e) {
      console.log(params, e)
      if (params && params.function) {
        params.function(e)
        return
      }
    },
    onMousemove() {
      if (this.$attrs.isFixedMenu) return
      try {
        this.$bus.emit('on-change-narrow-children', {
          bool: true,
          data: this.data
        })
      } catch (error) {
        this.$bus.$emit('on-change-narrow-children', {
          bool: true,
          data: this.data
        })
      }
    },

    onRouter(params) {
      console.log(params)

      // const loading = fetchEventSourceManager.onGetLoading();
      // if (loading) {
      //   fetchEventSourceManager.onCloseLink({isManualClose: true});
      // }
      try {
        this.$bus.emit('on-change-field-by-custom-textarea', {
          key: 'isSleep',
          value: false
        })
      } catch (error) {
        this.$bus.$emit('on-change-field-by-custom-textarea', {
          key: 'isSleep',
          value: false
        })
      }
      const timer = setTimeout(() => {
        this.$emit('update:activeRouteProp', params.meta.id)
        clearTimeout(timer)
      }, 10)
    }
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.c-menu_group_item {
  .level_one_wrap {
    margin-bottom: 4px;
    padding-right: 16px;
    .cmenu_item_wrap {
      &:hover {
        background: transparent;
        ::v-deep .label {
          color: #1d2129;
        }
      }
    }
  }
  .children_wrap {
    height: calc(100vh - 224px);
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    ::v-deep .el-scrollbar__bar.is-horizontal {
      display: none;
    }
    .top_wrap {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #86909c;
      line-height: 17px;
      margin-bottom: 8px;
      margin-left: 12px;
      &.my_dialog {
        position: relative;
        padding-top: 11px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          background-color: #e9ebf2;
          height: 1px;
          top: 0;
        }
      }
    }
    &__item {
      margin-bottom: 4px;
      &--cmenu {
        padding-left: 12px;
        padding-top: 7px;
        padding-bottom: 7px;
        padding-right: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .label {
          font-size: 13px;
          color: #1d2129;
          line-height: 18px;
          width: 200px;
          padding-right: 10px;
        }
        .more {
          color: #86909c;
          width: 16px;
          height: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          opacity: 0;
          transform: rotate(90deg);
          transform-origin: center;
          span {
            margin-right: 3px;
            width: 2px;
            font-size: 11px;
            display: flex;
            justify-content: center;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .moreBtn{
          width: 16px;
          height: 16px;
          cursor: pointer;
          margin-top: 1px;
          vertical-align: top;
        }
        &:hover {
          background: #fff;
          .more {
            opacity: 1;
          }
          .label {

          }
        }
        // &.is-active {
        .more {
          &:hover {
            // color: #165dff;
          }
        }
        // }
      }
      &:last-child {
        margin-bottom: 0;
        &:hover {
          .label {
            // color: #165dff !important;
          }
        }
      }
    }
  }

  .no_data_wrap {
    margin: 33px 0;
    text-align: center;
    padding-right: 16px;
    .icon {
      width: 64px !important;
      height: 64px !important;
      margin-bottom: 12px;
      vertical-align: top;
      ::v-deep .el-image__inner {
        border-radius: 0;
      }
    }
    .text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      font-size: 12px;
      color: #86909c;
      line-height: 17px;
    }
  }
  .icon_wrap{
    img{
      vertical-align: top;
    }
    
  }
}
</style>
